/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyercrophint2Inputs */

const en_flyercrophint2 = /** @type {(inputs: Flyercrophint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag inside the image to move the visible crop.`)
};

const de_flyercrophint2 = /** @type {(inputs: Flyercrophint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziehe im Bild, um den sichtbaren Ausschnitt zu verschieben.`)
};

/**
* | output |
* | --- |
* | "Drag inside the image to move the visible crop." |
*
* @param {Flyercrophint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyercrophint2 = /** @type {((inputs?: Flyercrophint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyercrophint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyercrophint2(inputs)
	return de_flyercrophint2(inputs)
});
export { flyercrophint2 as "flyerCropHint" }